import Vue from 'vue'
import moment from 'moment'
// import App from './App.vue'
import router from "./router.js";
import store from './store'

// layouts
import Master from '@/layouts/Master.vue'
import LandingLayout from '@/layouts/LandingLayout.vue'
import MainLayout from '@/layouts/MainLayout.vue'

import VModal from 'vue-js-modal'
import axios from "axios";
import './index.css';
import 'material-icons/iconfont/material-icons.css';



// Registering Layouts
import SearchSelect from '@/components/shared/SearchSelect.vue'
Vue.component('search-select', SearchSelect);
Vue.component('landing-layout', LandingLayout);
Vue.component('default-layout', MainLayout)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (!store.getters.loggedIn) {
			next({
				name: 'login',
			});
		} else {
			next();
		}
	} else if (to.matched.some(record => record.meta.requiresGuest)) {
		// this route requires auth, check if logged in
		// if yes, redirect to home page.
		if (store.getters.loggedIn) {
			next({
				name: 'landing',
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

// Единый формат дат в интерфейсе: 'YYYY-MM-DD' -> 'DD.MM.YYYY',
// ISO дата-время -> 'DD.MM.YYYY HH:mm'. Прочие строки возвращаются как есть.
Vue.filter('ddmmyyyy', value => {
  if (value === null || value === undefined || value === '') return '';
  const str = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return moment(str, 'YYYY-MM-DD', true).format('DD.MM.YYYY');
  }
  if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(str)) {
    const m = moment(str, moment.ISO_8601, true);
    return m.isValid() ? m.format('DD.MM.YYYY HH:mm') : str;
  }
  return str;
});
Vue.filter('TitleCase', value => {
	return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
});

Vue.use(VModal)

new Vue({
    router,
    store,
    axios,
    render: h => h(Master)
}).$mount('#app')
